module.exports = (error, next) => {
    next(error, null);
}


// WEBPACK FOOTER //
// ./src/libs/googleMyBusiness/errorHandler.js